import { render } from "./CatalogoMotivoPadrao.vue?vue&type=template&id=2e3262f4&ts=true"
import script from "./CatalogoMotivoPadrao.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoMotivoPadrao.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/estrutura-de-ponto-da-empresa/motivo-padrao/catalogo/apresentacao/CatalogoMotivoPadrao.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e3262f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e3262f4', __exports__)) {
    api.reload('2e3262f4', __exports__)
  }
  
  module.hot.accept("./CatalogoMotivoPadrao.vue?vue&type=template&id=2e3262f4&ts=true", () => {
    api.rerender('2e3262f4', render)
  })

}


export default __exports__